export enum ResidentStatusEnum {
  OWNER = 'OWNER',
  TENANT = 'TENANT',
}

export const getResidentStatusLabel = (value: ResidentStatusEnum): string => {
  switch (value) {
    case ResidentStatusEnum.OWNER:
      return $localize`Propriétaire`;
    case ResidentStatusEnum.TENANT:
      return $localize`Locataire`;
    default:
      return '';
  }
};
